// The shell's one-shot probe of the tenant feature `cms` (#160 AF20,
// src/core/cmsFeature.ts): the cheapest editor root, the audience catalogue.
import { graphql } from 'src/graphql'

export const CmsFeatureProbeDocument = graphql(/* GraphQL */ `
  query CmsFeatureProbe {
    cmsAudiences {
      id
    }
  }
`)
